export default "__VITE_ASSET__BNUV6LCf__"